// src/utils/tagTooltips.js
import tagTooltipsConfig from '../config/tagTooltips.json';


export const getTagTooltip = (domain, tag) => {
  if (!domain || !tag) return '';
  
  const domainConfig = tagTooltipsConfig[domain];
  if (!domainConfig) return '';
  
  const tagConfig = domainConfig[tag];
  if (!tagConfig) return '';
  
  return `${tagConfig.definition}\n\nExample: "${tagConfig.example}"`;
};

export const getDomainTooltip = (domain) => {
  if (!domain) return '';
  
  const domainConfig = tagTooltipsConfig[domain];
  if (!domainConfig) return '';
  
  const tagCount = Object.keys(domainConfig).length;
  const firstFewTags = Object.keys(domainConfig).slice(0, 3).join(', ');
  
  return `${domain} domain contains ${tagCount} tag types including: ${firstFewTags}...`;
};

// For debugging or admin purposes
export const getAllTooltips = () => tagTooltipsConfig;